import { baseOptionComparator } from './baseOptionComparator';

import type { SelectOption } from '../Select/SelectOption/SelectOption';

export function baseQuery(
  query: string,
  options: SelectOption[]
): SelectOption[] {
  return options.filter((option) => baseOptionComparator(option, query));
}
